import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'
import {
    eaveGableLengthUIOrder,
    eaveGableLengthUiSchema,
} from '../shared/constants/form-schema/eaveGableLength/uiSchema'
import { TOOLTIP_FOR_TWL_SIXTEEN_FIELD } from '../shared/constants/form-schema/general'
import {
    clearSoffitTypeForExposedSoffit,
    eaveGableLengthFormSubmitCleanUp,
} from '../shared/services/form-schema/eave-gable-length/helpers'

const uiSchema: UiSchema = {
    ...eaveGableLengthUiSchema('Eave'),

    vented_eave: {
        'ui:title': 'Vented Eave Soffit Panel',
        'ui:field': 'SwitchField',
    },
    eave_blocking_width: {
        'ui:placeholder': 'Select Eave Blocking Width',
    },
    include_eave_blocking: {
        'ui:title': 'Has Eave Blocking?',
        'ui:field': 'SectionDivider',
        'ui:options': {
            topDividerFieldType: 'switch',
            isLabelBold: true,
        },
    },
    eave_blocking_dimensions: {
        'ui:field': 'LumberDimensionsField',
        'ui:options': {
            tooltips: {
                length: {
                    text: TOOLTIP_FOR_TWL_SIXTEEN_FIELD,
                },
            },
        },
    },
    'ui:order': [
        'folder',
        'name',
        'label',
        'selection',
        'include_sub_fascia',
        'sub_fascia_dimensions',
        'include_eave_blocking',
        'eave_blocking_dimensions',
        'eave_blocking_width',
        ...eaveGableLengthUIOrder,
    ],
}

const onValidate = () => {}

const onUpdate = (_, formData) => clearSoffitTypeForExposedSoffit(formData)

const onSubmit = (settings, formData) => {
    const newSettings = eaveGableLengthFormSubmitCleanUp({ ...settings, ...formData })

    if (
        newSettings?.robust_rafter_tail &&
        ['dimensional lumber', 'panel (4x8)'].includes(newSettings.soffit_type?.toLowerCase())
    ) {
        newSettings.vented_eave = null
    }

    if (!newSettings?.robust_rafter_tail) {
        newSettings.eave_blocking_width = null
    }

    if (!formData.rafter_tail) {
        newSettings.rafter_tail = null
    }

    if (!formData.selection) {
        newSettings.selection = null
    }

    return newSettings
}

const form: FormProperties = { uiSchema, onValidate, onSubmit, onUpdate }

export default form
